module.exports = __webpack_public_path__ + "51380eceee6ebf259b8c96ff475448fc.svg";